// complete profile componenet, all this screen fields logic is written here
// ----------Imports-------------
import React, { useState, useEffect, useRef } from "react";
import { connect, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Formik, Field, Form } from "formik";
import Cookies from "universal-cookie";

//..........Constant imports...........
import CompleteProfile from "../CompleteProfile.json";
import { RoundCheckbox, errorMessage, PassportRadio, completeProfilePrefillFields } from "../../../constants/registration";
import * as Constants from "../../../constants/registration";
import { getCurrentMonth, IdsCheck } from "../../../utils/registrationUtils"
import { createCurrentUrl, placeholderData, getAbsoluteDestinationUrl, certificationPage,
     deviceType, convertToTitleCase } from "../../../utils/registrationUtils";
import { no_Numbers, mobile_number, no_special_characters, alphabet_Check } from "../../../constants/registration";
import {gaEvent, gaLocationAndContentData} from "../../../utils/index";

// .............Action imports................
import {
    getEducationLevelField, getInterestedInField,
    getCourseJoinPreferenceField, postSignUpData, getTertiaryCheckboxData,
    getAreaOfInterestField, getTargetedCountriesField
} from "../../../../store/slices/Registration/SignUpSlices";
import { getCountryCodeData, getUserAuthentication, postUserLoginSignupOtp, getUserAccountLimitCheck,postUserProfileClevertap } from "../../../../store/slices/Registration/CommonSlices";
import {postOtpVerifyCheck} from "../../../../store/slices/Registration/GoogleSignInSlice";
import * as actionTypes from "../../../../store/slices/Registration/SignUpSlices"

// ...........Component imports.............
import CareersRegisterRadio from "../CareersRegisterRadio";
import CareersRegisterControl from "../CareersRegisterControl";
import axios from "axios"

const CareersRegisterCompleteProfile = (props) => {
    // State hooks for various form fields and status
    const [radioBtn, setRadioBtn] = useState([]); // State for radio button options
    const [interestedInCheckbox, setInterestedInCheckbox] = useState([]); // State for checkbox options
    const [formikValues, setFormikValues] = useState({}); // State for formik form values
    const [fieldErrors, setFieldErrors] = useState({}); // State for form field errors
    const [tertiaryData, setTertiaryData] = useState([]); // State for tertiary data (checkboxes)
    const [touchedFields, setTouchedFields] = useState({}); // State for touched fields in form
    const cookies = new Cookies(); // Initialize cookies object
    let date = new Date(); // Get current date
    const navigate = useNavigate(); // Initialize navigate function from react-router
    const currentstateData = JSON.parse(sessionStorage.getItem("loginState")) || JSON.parse(sessionStorage.getItem("GoogleLogin"));
    const [formCurrentState, setFormCurrentState] = useState(cookies.get("loginState")?.userUuid ? null : cookies.get("registrationState")); // State for current form state from cookies
    const [formCurrentStateLogin, setFormCurrentStateLogin] = useState((currentstateData || cookies.get("loginState")) || null); // State for current login state from session storage
    const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME // Determine the destination domain
    const [reinitialize, setReinitialize] = useState(true); // Flag to reinitialize form
    const [syncSignupValues, setSyncSignupValues] = useState({}); // State to sync signup values
    const [currentFields, setCurrentFields] = useState(0); // State for current number of fields
    const [remainingSeconds, setRemainingSeconds] = useState(Math.abs(localStorage.getItem("remainingSeconds") ? Math.abs(30 - Math.abs(localStorage.getItem("remainingSeconds") - new Date().getSeconds())) : 0));
    const [isConsentChecked, setIsConsentChecked] = useState(true); // State for consent checkbox
    const { otpVerifyCheck, otpVerifyLoading,  otpVerifyError} = useSelector((state) => state.usersGoogleSiginIn)
    // Check current URL
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
        window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/otp-verify"];
    const currentDeferrerUrl = document.referrer
    const currentCookieUrl = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const isMatch = urls.some(path => currentDeferrerUrl?.includes(path));
    const currentUrl = isMatch ? currentCookieUrl : currentDeferrerUrl;
    // const currentUrl = document.referrer ? document.referrer : cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
    const urlObj = currentUrl ? new URL(currentUrl) : null;
    const cleanUrl = urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
    const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();

    // Check added for tertiary checkbox show.
    let targetYearCheck = (props.domain?.id == 3 || props.domain?.id == 4) ? formikValues?.education_level?.id > 13 : false;
    let targetYearValue = targetYearCheck ? formikValues?.target_year : true;
    let tertairyCheckboxShow = formikValues?.education_level && formikValues?.location?.id && targetYearValue && (formikValues?.education_interest || formikValues?.aspiring_stream);
    //---------------------------------------  
    const checkOneClickMobile = cookies?.get("loginState")?.ask_mobile_verify;
    // submit button disable check 
    let  submitButtonEnable = (isConsentChecked && Object.keys(fieldErrors)?.length == 0 && formikValues?.education_level?.id && (props.userDetails?.ask_mobile_verify ? otpVerifyCheck : true));

    //Get prefered education stream level from cookies
    const preferredLevelStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefferred_level_streams;
    // const preferredStreamData = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.preffered_streams;

    const isInitialLoad = useRef(true);

    const loginDataCookies = cookies?.get("loginState");
    const oneClickUuid = cookies?.get("one-click-login")?.data?.uuid;
    const currentUUID = oneClickUuid ? oneClickUuid : loginDataCookies?.userUuid ? loginDataCookies?.userUuid : loginDataCookies?.user_uuid;
    
    // const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/login/otp-verify"];
    // const isMatch = urls.some(path => currentUrl?.includes(path)); // Check if the current URL matches any of the specified paths
    // Effect to save form data
    useEffect(() => {
        if (isInitialLoad.current && props.userDetails && props.geolocationData && formCurrentStateLogin) {
        signupDataPostSave(); // call only on first load if data is present
        isInitialLoad.current = false; // prevent future calls (e.g. refresh)
        }
    }, [props.userDetails, props.geolocationData, formCurrentStateLogin]);

    // Effect to handle beforeunload event to prevent accidental page refresh
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            // Cancel the event to prevent the page from refreshing immediately
            event.preventDefault();
        };

        if (currentFields > 1 && props.reloadFlagOnExit) {
            window.addEventListener('beforeunload', handleBeforeUnload);
        }
        return (() => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        });
    }, [currentFields, props.reloadFlagOnExit]);

    // Effect to populate form values from current state
    useEffect(() => {
        setTimeout(() => setReinitialize(false), 500);
        CallingOnLoadActions();
    }, []);

    // Effect to fetch tertiary checkbox data based on various fields
    useEffect(() => {
        if (props.geolocationData) {
                let params = {};
                params.state_id = formikValues?.location?.state_id;
                params.level_id = formikValues?.education_level?.id;
                if (formikValues?.education_interest)
                    params.education_stream = formikValues?.education_interest.domain_id;
                if (formikValues?.aspiring_stream)
                    params.aspiring_stream = formikValues?.aspiring_stream?.id;
                if (formikValues?.target_year)
                    params.target_year = formikValues?.target_year?.id;
                if(formikValues?.passing_year)
                    params.passing_year = formikValues?.passing_year?.id;
                if (tertairyCheckboxShow){
                    props.dispatch(getTertiaryCheckboxData(params));
                }   
            }
    }, [props.geolocationData, formikValues?.education_level, formikValues?.location, formikValues?.education_interest, formikValues?.target_year, formikValues?.aspiring_stream]);

    // Effect to segregate data for radio buttons and checkboxes
    useEffect(() => {
        // handling prefilled data through cookies for checkboxes
        if (props.dropdownData?.interested_in) {
            setInterestedInCheckbox(props.dropdownData?.interested_in?.values);
            if (props.domain.id == 2) {
                let updatedCheckBoxes = props.dropdownData?.interested_in?.values?.filter((obj, ind) => {
                    if ([1, 2].includes(obj.preference_id)) return obj;
                });
                setFormikValues((prev) => ({ ...prev, "interested_in": updatedCheckBoxes }));
                setReinitialize(true);
                setTimeout(() => setReinitialize(false), 50);
            }
        }
    }, [props.dropdownData?.interested_in]);

    // Effect to set tertiary data
    useEffect(() => {
        if (props.tertiaryChecboxData)
            setTertiaryData(RoundCheckbox);

    }, [props.tertiaryChecboxData]);

    // Effect to set radio button data for course joining preference
    useEffect(() => {
        if (props.dropdownData?.course_joining_preference && props.domain?.id == 2)
            setRadioBtn(props.dropdownData?.course_joining_preference?.values);

    }, [props.dropdownData?.course_joining_preference]);  

    useEffect(() => {  //user auth check mobile
        if (formikValues?.mobile && !fieldErrors?.mobile) {
          let params = {};
          params.mobile_number = formikValues?.mobile
          props.dispatch(getUserAuthentication(params));
          params.email = formCurrentStateLogin?.email ? formCurrentStateLogin?.email : props.userDetails?.email;
          props.dispatch(getUserAccountLimitCheck(params))
          signupDataPostSave("save", null, null, formikValues?.mobile, null ); 
        }
      }, [formikValues?.mobile, fieldErrors?.mobile])  
      
      // Prefill form fields based on user data and required fields
      useEffect(() => {
        if(props.userDetails){
          prefillFieldsData();
        }
      },[props.userDetails])
      const prefillFieldsData = () => {
            // Merge only the fields specified in completeProfilePrefillFields
            const updatedValues = completeProfilePrefillFields.reduce((acc, field) => {
                // If the field is 'name', store the value in 'studentname'
                if (field === "display_name" && props.userDetails?.[field]) {
                  acc.studentname = props.userDetails?.[field];
                } else if (field === "education_level" && props.userDetails?.[field]?.id) {
                    // Transform education_level structure
                    acc.education_level = {
                      id: props.userDetails.education_level.id,
                      title: props.userDetails.education_level.parent_level_name,
                      label: props.userDetails.education_level.value,
                    };
                  } else if(field === "school_board" && props.userDetails?.[field]?.id){
                    acc.school_board = {
                        id: props.userDetails?.school_board?.id,
                        label: props.userDetails?.school_board?.value
                    };
                  }
                  else if (props.userDetails?.[field]?.id) {
                    acc.location = {
                        id: props.userDetails.location.id,
                        label: props.userDetails.location.city_name,
                        state_id: props.userDetails.location.state_id
                    }
                  }
            
                return acc;    
            }, {});
            setFormikValues((prevValues) => ({
              ...prevValues,
              ...updatedValues,
            }));
            setReinitialize(true)
            setTimeout(() => setReinitialize(false), 50);
      }

      //Handle calling actions on load with common params 
    const CallingOnLoadActions = () => {
        let preferedEducationLevel = cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.prefered_education_level;
        let param = {};
        param.current_url = sourseDestination;
        param.page_url = sourseDestination;
        param.certification = props.domain?.id == 2 ? "True" : "False";
        props.dispatch(getCountryCodeData({ ...param, field: "country_code" }));
        if (props.domain.id == 3) setRadioBtn(PassportRadio);
        let paramLevel = {...param}
        paramLevel.field = "education_level";
        if(preferedEducationLevel){
        paramLevel.preferred_level = typeof preferedEducationLevel === 'object' ? Object.keys(preferedEducationLevel)?.[0] : preferedEducationLevel;
        }
        props.dispatch(getEducationLevelField(paramLevel));

        if (props.domain?.id != 1 && props.domain?.id != 5) props.dispatch(getInterestedInField({ ...param, field: "interested_in" }));
        if (props.domain?.id == 2) props.dispatch(getCourseJoinPreferenceField({ ...param, field: "course_joining_preference" }));
      if (props.domain?.id == 3) props.dispatch(getTargetedCountriesField({ ...param, field: "country"}))
    }

    // Function to validate form values
    const validate = (values) => {
        let errors = {};

        
        // Validation for city
        if (!values.location?.id) {
            errors.location = "Please search & select your city from the list.";
        }
        if (!values.education_level) {
            errors.education_level = "Please select what you are currently doing.";
        }

        // Validation for targeting countries
        if (!values.country && props.domain?.id == 3) {
            errors.country = "Please select your interested countries.";
        }
        if (props.domain?.id == 2 && (!values.interested_in || values.interested_in?.length === 0)) {
            errors.interested_in = "Please select your interest.";
        }

        // Validation for dynamic fields/dropdowns
        AllFieldsData(values, "Primary")?.map((item, index) => {
            // Validation for student name
                if(item.name == "studentname"){
                    if (!values.studentname && props.domain?.id == 1) {
                        errors.studentname = "Please enter student's name.";
                    } else if (!values.studentname && props.domain?.id != 1) {
                        errors.studentname = "Please enter your name.";
                    } else {
                        if (no_Numbers.test(values.studentname?.trim())) {
                            errors.studentname = "Name should not contain numbers.";
                        }
                        if (no_special_characters.test(values.studentname?.trim())) {
                            errors.studentname = "Name should not contain special character.";
                        }
                        if (values.studentname?.trim().length < 2 || values.studentname?.trim().length > 60) {
                            errors.studentname = "Invalid name. Please enter 2 to 60 characters.";
                        }
                    }
                }

                //mobile
                if(item.name == "mobile"){
                    if (!values.mobile) {
                        errors.mobile = "Please enter your mobile number.";
                    }
                    else if (mobile_number.test(values.mobile)) {
                        errors.mobile = "Invalid mobile. Must start with 6,7,8,9.";
                    }
                    else if (values.mobile?.length != 10) {
                        errors.mobile = "Invalid mobile. Must have 10 digits.";
                    }
                    else if (no_special_characters.test(values.mobile)) {
                        errors.mobile = "Invalid mobile. No special character accepted.";
                    }
                    else if (alphabet_Check.test(values.mobile)) {
                        errors.mobile = "Invalid mobile. Aplhabets are not allowed.";
                    }
                }
                    let fieldName = convertToTitleCase(item.name);
        
                    let labelMatched = errorMessage.find((error) => error.label === item.name);
                    if (item.name != "interested_in" && (!values[item.name] || values[item.name].length === 0)) {
                        if (item.name == "aspiring_stream" && values.education_level?.id <= 10) {
                            errors.aspiring_stream = "Please select interested subjects' stream.";
                        } else if (item.name == "aspiring_stream" && values.education_level?.id > 10) {
                            errors.aspiring_stream = "Please select your current stream in school.";
                        } else if (item.name == "education_interest" && values.education_level?.id <= 10) {
                            errors.education_interest = "Please select your interested stream for college.";
                        } else if (item.name == "education_interest" && values.education_level?.id >= 11) {
                            errors.education_interest = "Please select college course interested in.";
                        } else if (item.name == "degree_pursue" && ((values?.education_level?.id >= 22 && values?.education_level?.id <= 25) || values?.education_level?.id > 28)){
                            errors.degree_pursue = "Please select your completed degree."
                        } else {
                            errors[item.name] = labelMatched ? labelMatched.message : `${fieldName} field is required.`;
                        } 
                    }
                }
            );

        setFormCurrentState((prev) => ({ ...prev, errors }));
        return errors;
    };

    const AllFieldsData = (values, type, click) => {
        let fieldData = CompleteProfile?.data
        ?.find((obj) => obj.domain == props.domain?.id)
        ?.fields?.filter((item, index) => {
            let interestedInFields = Array.isArray(values?.interested_in) && values?.interested_in?.length > 0 && values.interested_in?.find((obj) =>
                item.interested_in?.includes(obj.preference_id))
            let isTotalFields = item.dependency_type == "AND" ? item.education_level?.includes(values?.education_level?.id)
                && item.interested_in?.includes(interestedInFields?.preference_id) :
                item.education_level?.includes(values?.education_level?.id)
            if (item.name == "area_of_interest" && !(values?.certificate_interest || values?.education_interest)) {
                isTotalFields = false
            }
            let renderField = false
            if (item.name == "passing_year") {
                if (["March", "April"]?.includes(getCurrentMonth()) || values?.education_level?.id == 13) {
                    renderField = true
                }
            }else {
                renderField = true
            }
            let googleSignInField = false
            if(item.name == "mobile" || item.name == "otp"){
                if(props.userDetails?.ask_mobile_verify){
                googleSignInField = true;
                }
            }else{
                googleSignInField = true;
            }
            let renderNameField = false;
            if(item.name == "studentname") {
                if(!!formCurrentStateLogin?.isGoogleLogin){
                    if(!!formCurrentStateLogin?.ask_user_name){
                        renderNameField = true;
                    }
                }else {
                    renderNameField = true;
                }
            }else {
                renderNameField = true;
            }

            if (type == "Primary" && (item.type == "Primary" || isTotalFields) && renderField && renderNameField && googleSignInField) { // checks for loading fields according to requirements.
                return item;
            }
            if (type == "Secondary" && item.type == "Secondary" && isTotalFields && renderField) { // check for calling api based on level selected.
                return item;
            }
        })
        if(click == "GA") gaEvent("signincompleteprofilesubmit", "login_signup", `${gaLocationAndContentData}`, "");
        return fieldData;
    }

    // Function to update touched fields state
    const updateTouchedFields = (touched) => {
        setFormCurrentState((prev) => ({ ...prev, touched }));
    }

        // Handle consent checkbox change event
        const handleConsentCheckboxChange = (event) => {
            setIsConsentChecked(event.target.checked);
        };
    const signupDataPostSave = (type, level, name, mobile, location, school_board) => {
        let formValues = cookies.get("loginState")?.formValues;
            const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
            let obj = {
                current_url: sourseDestination,
                destination: destinationUrl,
                page_url: sourseDestination,
                cta_clicked: cookies.get("loginState")?.isGoogleLogin ? "google" : "login",
                country_code: "+91",
                location: location?.id ? location?.id : props.userDetails?.location?.id ? props.userDetails?.location?.id : formikValues?.location?.id,
                current_location:  props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "",
                education_level: level?.id ? level?.id : formikValues?.education_level?.id ? formikValues?.education_level?.id : props.userDetails?.education_level?.id,
                name: name?.trim() ?? formikValues?.studentname?.trim(),
                user_uuid: currentUUID,
                user_type: "new_user",
                certification: props.domain?.id == 2 ? true : false,
                email : formCurrentStateLogin?.email ? formCurrentStateLogin?.email : props.userDetails?.email,
                school_board : school_board?.id ? school_board?.id : formikValues?.school_board?.id
            };
            if(!fieldErrors.mobile){
                obj.mobile_number = mobile ? mobile : formikValues?.mobile ? formikValues?.mobile : formValues?.mobile;
            }
            if (cookies.get("loginState")?.cta_clicked == "one_click") {
                obj.url_source = "one_click_url";
                obj.form_type = "complete_profile";
            }
            props.dispatch(postSignUpData(obj));
            // props.dispatch(postUserProfileClevertap({ ...obj, incomplete_user: 1 })); 
            // props.dispatch(postUserProfileClevertap(obj,incomplete_user:1));
    };
    return (
        <>
            
                <div className="careers_register_tab">
                    <h5><b>Complete your Profile</b></h5>
                    <div className="update_profile_description">
                       Help us provide better recommendations by sharing your preferences!
                    </div>

                    <Formik
                        initialValues={formikValues}
                        enableReinitialize={reinitialize}
                        validate={validate}
                        onSubmit={(values, { setSubmitting }) => {
                            const errors = validate(values);
                            setFieldErrors(errors);
                        }}
                        initialTouched={touchedFields}
                        initialErrors={fieldErrors}
                    >
                        {({
                            values,
                            handleChange,
                            setFieldValue,
                            errors,
                            touched,
                            handleBlur,
                            handleSubmit,
                            setTouched
                        }) => {
                            // useEffect to update formikValues and call validate function whenever form values change
                            useEffect(() => {
                                setFormikValues(values);
                                props.setClevertapValues(values);
                                setFormCurrentState((prev) => ({ ...prev, formValues: values }));
                                setFormCurrentStateLogin((prev) => ({ ...prev, formValues: values }));
                                const errors = validate(values);
                                setFieldErrors(errors);
                                countCurrentFields();
                            }, [values]);

                            // Function to count non-empty form fields
                            const countCurrentFields = () => {
                                let count = 0;
                                for (const key in values) {
                                    if (values.hasOwnProperty(key) && values[key] !== null && values[key] !== "") {
                                        count++;
                                        setCurrentFields(count);
                                    }
                                }
                            };

                            const SendOtpOnMobile = () => {
                                if(props.usersAuthentication) {
                                let params = {};
                                params.otp_on = "mobile";
                                params.cta_clicked = cookies.get("loginState")?.cta_clicked ? cookies.get("loginState")?.cta_clicked : "login";
                                params.otp_action = "send";
                                params.isd_code = "+91";
                                params.mobile_number = formikValues?.mobile;
                                props.dispatch(postUserLoginSignupOtp(params));
                              } 
                            }
                            const handleOtpVerify = () => {
                                let obj = {};
                                obj.cta_clicked = cookies.get("loginState")?.cta_clicked ? cookies.get("loginState")?.cta_clicked : "login";
                                obj.isd_code = "+91";
                                obj.mobile_number = values.mobile;
                                obj.otp_on = "mobile";
                                if(!cookies.get("loginState")?.cta_clicked){
                                    obj.google_status= 1;
                                }
                                obj.otp = values.otp;
                                // if(formCurrentStateLogin?.user_uuid){
                                // obj.user_uuid= formCurrentStateLogin?.user_uuid;
                                // }else {
                                // obj.user_uuid = formCurrentStateLogin?.userUuid;
                                // }
                                obj.user_uuid = currentUUID;
                                props.dispatch(postOtpVerifyCheck(obj));
                            }

                            // Function to post signup data if validation passes
                            const signupDataPost = () => {
                                let formValues = cookies.get("loginState")?.formValues;
                                if (submitButtonEnable) {
                                    const destinationUrl = getAbsoluteDestinationUrl() || createCurrentUrl();
                                    let obj = {
                                        current_url: window.location.href,
                                        page_url:sourseDestination,
                                        destination: destinationUrl,
                                        cta_clicked: formCurrentStateLogin?.isGoogleLogin ? "google" : "login",
                                        country_code: "+91",
                                        location: formikValues?.location?.id,
                                        current_location:  props.geolocationData?.city ? `${props.geolocationData?.city},${props.geolocationData?.state},${props.geolocationData?.country}` : "",
                                        education_level: formikValues?.education_level?.id,
                                        name: formikValues?.studentname?.trim(),
                                        interested_in: formikValues.interested_in?.length > 0 ? IdsCheck(formikValues?.interested_in) : [],
                                        user_uuid: currentUUID,
                                        user_type: "new_user",
                                        checkbox_id: props.tertiaryChecboxData?.id ?? 0,
                                        checkbox_status: formikValues?.tertiary_checkbox?.[0]?.id == 1 ? true : false,
                                        certification: props.domain?.id == 2 ? true : false,
                                        email : formCurrentStateLogin?.email ? formCurrentStateLogin?.email : props.userDetails?.email,
                                        mobile_number: values?.mobile ? values?.mobile : formValues?.mobile,
                                    };
                                     obj.submit= true;
                                    if (props.userDetails?.ask_mobile_verify) obj.mobile_verify = 1;
                                    if (formikValues?.passing_year) obj.passing_year = formikValues?.passing_year?.id;
                                    if (formikValues?.aspiring_stream) obj.aspiring_stream = formikValues?.aspiring_stream?.id;
                                    if (formikValues?.degree_pursue) obj.degree_pursue = formikValues.degree_pursue?.id;
                                    if (formikValues?.target_year) obj.target_year = formikValues.target_year?.id;
                                    if (formikValues?.work_experience) obj.work_experience = JSON.stringify(formikValues.work_experience?.id);
                                    if (formikValues?.education_interest) {
                                        if (formikValues?.education_interest?.id) obj.degree_interested = formikValues?.education_interest?.id;
                                        if (formikValues?.education_interest?.group_id) obj.is_group = true;
                                        obj.domain_id = formikValues?.education_interest?.domain_id;
                                    }
                                    if (formikValues.passport?.length > 0) obj.passport = formikValues.passport?.[0]?.id;
                                    if (formikValues.course_joining_preference) obj.course_joining_preference = formikValues?.course_joining_preference?.[0]?.id;
                                    if (formikValues.area_of_interest?.length > 0) obj.area_of_interest = formikValues?.area_of_interest;
                                    if (formikValues?.country?.length > 0) obj.country = IdsCheck(formikValues?.country);
                                    if (formikValues.certificate_interest) obj.certificate_interest = formikValues.certificate_interest?.domain_id;
                                    if (cookies.get("loginState")?.cta_clicked == "one_click") {
                                        obj.url_source = "one_click_url";
                                        obj.form_type = "complete_profile";
                                    }
                                    if(formikValues?.school_board?.id){
                                        obj.school_board = formikValues?.school_board?.id
                                    }
                                    props.dispatch(postSignUpData(obj));
                                    // props.dispatch(postUserProfileClevertap(obj));
                                }
                            };

                            // Handle checkbox changes
                            const handleInterestedCheckbox = (item, id) => {
                                const updatedCheckboxes = interestedInCheckbox?.map((checkbox) =>
                                    checkbox.preference_id === id ? { ...checkbox, selected: !checkbox.selected } : checkbox
                                );
                                setInterestedInCheckbox(updatedCheckboxes);
                                setFieldValue(
                                    item?.name,
                                    updatedCheckboxes?.filter((obj) => obj.selected)
                                );
                            };

                            // Handle radio button changes
                            const handleRadioChange = (item, id) => {
                                const updatedCheckboxes = radioBtn?.map((checkbox) => ({
                                    ...checkbox,
                                    selected: checkbox.id === id,
                                }));
                                setRadioBtn(updatedCheckboxes);
                                setFieldValue(
                                    item?.name,
                                    updatedCheckboxes?.filter((obj) => obj.selected)
                                );
                            };

                            // Handle tertiary checkbox changes
                            const handleTertiaryChange = (item, id) => {
                                const tertiaryRadio = tertiaryData?.map((checkbox) => ({
                                    ...checkbox,
                                    selected: checkbox.id === id,
                                }));
                                setTertiaryData(tertiaryRadio);
                                setFieldValue(
                                    "tertiary_checkbox",
                                    tertiaryRadio?.filter((obj) => obj.selected)
                                );
                            };
                            // need to be removed
                            const handleOnFocus = (event, name, item) => {
                                console.log("")
                            }

                            // call updated fields api based on education level
                            const apiCallBasedOnStudyingIn = (name, option) => {
                                values = {...values, [name]: option}
                
                                updateTouchedFields({ ...touched, [`${name}`]: true })
                                
                                if(AllFieldsData(values, "Secondary")?.length > 0){
                                // Dynamically call the actions
                                AllFieldsData(values, "Secondary", null)?.forEach((obj) => {
                                const actionCreator = actionTypes[obj.actionName];
                                if (typeof actionCreator === 'function' && !["interested_in", "course_joining_preference", "passport"]?.includes(obj.name)){
                                    let params = {};
                                    params.current_url = createCurrentUrl();
                                    params.page_url = sourseDestination;
                                    params.certification = props.domain?.id == 2 ? "True" : "False";
                                    if (values?.education_level?.id)
                                    params.education_level = values?.education_level?.id;
                                    if (values.interested_in?.length > 0)
                                    params.interested_in = `${IdsCheck(values?.interested_in)?.join(',')}`;
                                    if(obj.name == "education_interest" && preferredLevelStreamData?.length > 0){ 
                                        params.preferred_stream_level = JSON.stringify(preferredLevelStreamData);
                                    // if (preferredStreamData?.length > 0) params.preferredStreamData = JSON.stringify(preferredStreamData);
                                    }
                                    // Dispatch the action here or call it directly
                                    params.field = `${obj.name}`;
                                    props.dispatch(actionCreator(params));
                                }
                                })};
                            };

                            // Function to call area of interest API
                            const areaOfInterestApiCall = (level = values?.education_level, interest = values.interested_in, eduInterest = values?.education_interest, cerInterest = values?.certificate_interest) => {
                                let params = {};
                                updateTouchedFields({ ...touched, ["area_of_interest"]: true });
                                params.current_url = window.location.href;
                                params.page_url = sourseDestination;
                                params.field = "area_of_interest";
                                params.certification = props.domain?.id == 2 ? "True" : "False";
                                if (level?.id) params.education_level = level?.id;
                                if (eduInterest && (interest?.[0]?.preference_id ? IdsCheck(interest)?.includes(1) : interest?.includes(1))) {
                                    if (eduInterest?.id) params.degree_interested = eduInterest?.id;
                                    if (eduInterest?.group_id) params.is_group = true;
                                    params.domain_id = eduInterest?.domain_id;
                                }
                                if (interest?.length > 0) params.interested_in = interest?.[0]?.preference_id ? `${IdsCheck(interest)?.join(',')}` : interest?.length > 0 ? interest?.join(',') : [];
                                if (cerInterest && (interest?.[0]?.preference_id ? IdsCheck(interest)?.includes(2) : interest?.includes(2))) params.certificate_interest = cerInterest?.domain_id;
                                props.dispatch(getAreaOfInterestField(params));
                            };

                            return (
                                <><Form onSubmit={handleSubmit}>
                                    <>
                                        <Row>
                                            {/* To call the component for dynamic fields/dropdowns as per registration data */}
                                            {AllFieldsData(values, "Primary")?.map((item, index) => {
                                                    return (
                                                        <Col
                                                            md={
                                                                item.fieldType == "checkbox" ||
                                                                    item.fieldType == "radio"
                                                                    ? "12"
                                                                    : "6"
                                                            }
                                                        >
                                                            <CareersRegisterControl
                                                                item={item}
                                                                control={item?.fieldType}
                                                                name={item?.name}
                                                                label={item?.label}
                                                                handleChange={handleChange}
                                                                setFieldValue={setFieldValue}
                                                                values={values}
                                                                errors={errors}
                                                                touched={touched}
                                                                constants={Constants[item?.options]}
                                                                fieldSelectType={item?.fieldSelectType}
                                                                placeholder={placeholderData(item, values)}
                                                                maxLimit={item?.maxLimit}
                                                                handleBlur={handleBlur}
                                                                dropdownData={props.dropdownData[item.name]}
                                                                domain={props.domain}
                                                                interestedInCheckbox={interestedInCheckbox}
                                                                setInterestedInCheckbox={setInterestedInCheckbox}
                                                                handleInterestedCheckbox={(e, id) =>
                                                                    handleInterestedCheckbox(item, id)
                                                                }
                                                                radioBtn={radioBtn}
                                                                handleRadioChange={(e, id) => handleRadioChange(item, id)}
                                                                handleOnFocus={(event) => handleOnFocus(event, item.name, item)}
                                                                searchBar={item.searchBar}
                                                                geolocationData={props.geolocationData}
                                                                updateTouchedFields={updateTouchedFields}
                                                                setTouched={setTouched}
                                                                setFormikValues={setFormikValues}
                                                                setSyncSignupValues={setSyncSignupValues}
                                                                setReinitialize={setReinitialize}
                                                                areaOfInterestApiCall={(level, interest, eduInterest, cerInterest) => areaOfInterestApiCall(level, interest, eduInterest, cerInterest)}
                                                                apiCallBasedOnStudyingIn={(name, option) => apiCallBasedOnStudyingIn(name, option)}
                                                                SendOtpOnMobile={() => SendOtpOnMobile()}
                                                                handleOtpVerify={() => handleOtpVerify()}
                                                                setFormCurrentState={setFormCurrentState}
                                                                formCurrentState={formCurrentState}
                                                                setRemainingSeconds={setRemainingSeconds}
                                                                remainingSeconds={remainingSeconds}
                                                                signupDataPost={(type, level, name, mobile, location, school_board)=> signupDataPostSave(type, level, name, mobile, location,school_board)}
                                                            />
                                                        </Col>
                                                    );
                                                })}
                                            {tertairyCheckboxShow && props.tertiaryChecboxData?.id && tertiaryData && 
                                                <CareersRegisterRadio
                                                    name={"tertiary_checkbox"}
                                                    localStorageData={formikValues.tertiary_checkbox}
                                                    setFieldValue={setFieldValue}
                                                    values={values}
                                                    errors={errors}
                                                    constants={props.constants}
                                                    radioBtn={tertiaryData}
                                                    handleRadioChange={(item, id) =>
                                                        handleTertiaryChange(item, id)
                                                    }
                                                    tertiaryChecboxData={props.tertiaryChecboxData}
                                                    tertiaryChecboxLoading={props.tertiaryChecboxLoading}
                                                />}
                                        </Row>

                                        {/* checkbox for terms and condition */}

                                        {formCurrentStateLogin?.isGoogleLogin && (
                                            <div className="careers_register_custom_checkbox">
                                                <Field type="checkbox" id="terms" name="terms"
                                                    checked={isConsentChecked}
                                                    onChange={(e) => {
                                                        handleConsentCheckboxChange(e)
                                                    }}
                                                    required />
                                                <label htmlFor="terms" className="careers_register_terms">
                                                    <span> I agree to Careers360’s <a className="careers_register_terms_and_condition" href="https://www.careers360.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy </a>
                                                        and <a className="careers_register_terms_and_condition" href="https://www.careers360.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms &
                                                            Conditions</a> and provide consent to be contacted for promotion via mail, sms, whatsapp, rcs etc.
                                                    </span>
                                                </label>
                                            </div>
                                        )}
                                        
                                        {props.errorToaster && <div className="success_card">Something went wrong..please try login again.</div>}
                                        
                                        <button
                                            type="submit"
                                            disabled={submitButtonEnable && !props.postSignupDataLoading ? false : true}
                                            className={submitButtonEnable ?
                                                "careers_register_valid_button careers_register_button"
                                                : "careers_register_button"}
                                            onClick={() => {signupDataPost(); AllFieldsData(values, "Primary", "GA");}}
                                        >
                                            Submit
                                        </button>
                                    </>
                                </Form>
                                </>
                            );
                        }}
                    </Formik>
                </div>
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        dropdownData: state.userSignUpFields,
        usersAuthentication: state.usersCommonData?.userAuthentication,
        usersAuthenticationError: state.usersCommonData?.userAuthenticationError,
        userIps: state.usersCommonData?.userIp,
        geolocationData: state.usersCommonData?.geoLocation,
        postSignupData: state.userSignUpFields?.signupData,
        postSignupDataLoading: state.userSignUpFields?.signupDataLoading,
        signupDataError: state.userSignUpFields?.signupDataError,
        usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
        loginDatas: state.usersCommonData?.loginData,
        usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
        tertiaryChecboxData: state.userSignUpFields?.tertiaryChecbox,
        tertiaryChecboxLoading: state.userSignUpFields?.tertiaryChecboxLoading,
        countryCodeData: state.usersCommonData?.countryCode,
        userDetails: state.usersCommonData?.userInfo
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CareersRegisterCompleteProfile);